import { ICON_HEIGHT_16, IconNG } from '../../Icon'
import { ListItemIcons } from '../../ListItem'

import { getUserMenuThemeModeArrowColor } from './UserMenuThemeModeArrow.utils'

import ChevronRightIcon from '../../../icons/chevrons/right.svg'

function UserMenuThemeModeArrow({ isHovered, isSelected }) {
  return (
    <ListItemIcons>
      <IconNG
        Icon={ChevronRightIcon}
        color={getUserMenuThemeModeArrowColor({ isHovered, isSelected })}
        size={ICON_HEIGHT_16}
      />
    </ListItemIcons>
  )
}

export default UserMenuThemeModeArrow
